import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/debounceTime';
import Config from 'Config';
import {toggleSort} from 'utils/DBUtils';
import * as ResourceApi from 'api/resources';
import {Types as ImageActionTypes} from 'pages/Images/actions';
import {sortOptionsFactory, filterOptionsFactory} from 'viewOptions/factories';
import {Types as SearchActionTypes, receivedSearchResults, clearSearchResults} from './actions';
import {FiltersByResourceType} from './utils';

const editedImageEpic = action$ => action$.ofType(ImageActionTypes.END_EDIT_IMAGE)
  .mapTo(clearSearchResults(ResourceApi.Types.Image));

const searchEpic = action$ => action$.ofType(SearchActionTypes.SEARCH_QUERY_CHANGED)
  .debounceTime(Config.SEARCH_REQUEST_DEBOUNCE_TIME)
  .mergeMap(({resourceType, searchQuery}) => {
    const sortOptions = sortOptionsFactory('_created');
    sortOptions.sorts = toggleSort(sortOptions.sorts, '_created');

    const filterOptions = filterOptionsFactory(resourceType in FiltersByResourceType ? {
      filters: FiltersByResourceType[resourceType]
    } : {});

    // when searching for Winners, we're really just filtering on PrizeEntry where winner = true.
    const searchableType = resourceType === ResourceApi.Types.Winner ? ResourceApi.Types.PrizeEntry : resourceType;

    return ResourceApi.searchResources(searchableType, searchQuery, sortOptions, filterOptions).map(response => {
      return receivedSearchResults(resourceType, response.response.object);
    });
  })
  .catch(error => Observable.of({type: 'ERROR', error}));

export default [
  editedImageEpic,
  searchEpic
];



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/epics.js